export enum Page {
  JASON = 'JASON',
  MATT = 'MATT',
  JAMES = 'JAMES',
  FAMILY = 'FAMILY',
}
